import React from "react";

import { InputInfo } from "./InputInfo";

import { Text, TextProps } from "../../../atoms/Text";
import { useInputField } from "../InputContext";

/**
 * A label that is displayed alongside the input
 */
export const InputLabel = React.forwardRef<HTMLLabelElement, Partial<Omit<TextProps, "htmlFor">>>(
	({ size = "paragraph-3", weight = "semi-bold", color, children = "", ...rest }, ref) => {
		const { error, disabled, id, required, disableLabelClick } = useInputField();

		return (
			<div className="flex items-center">
				<Text
					id={"label-" + id}
					ref={ref}
					overrideElement="label"
					size={size}
					weight={weight}
					color={error ? "red-5" : disabled ? "neutral-5" : (color ?? "neutral-9")}
					htmlFor={disableLabelClick ? undefined : id}
					{...rest}
				>
					{children}
					{required && (
						// no size class, so the asterisk inherits the label's and stays proportional
						// at every labelSize. no vertical-align either: the glyph already sits high in
						// its em box, and super lifted it out of the line box once it matched the label
						<span aria-hidden="true" className="text-red-5" data-testid="required-indicator">
							*
						</span>
					)}
				</Text>
				<InputInfo />
			</div>
		);
	}
);
InputLabel.displayName = "InputLabel";
